import React, { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  SAVE_WARNING_MESSAGE,
  SCHEDULE_WARNING_MESSAGE,
} from '../../../../constants/strings';
import SliderCard from '../../../SliderCard';
import palette from '../../../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  text: {
    fontFamily: 'Roboto',
    textTransform: 'capitalize',
    fontSize: typography.pxToRem(18),
    lineHeight: typography.pxToRem(20),
    color: palette.typography.black.high,
  },
  bold: {
    fontWeight: 500,
  },
}));

const SummaryCard = ({ title, successMessage, routeCode }) => {
  const classes = useStyles();

  return (
    <SliderCard title={title}>
      <Box>
        <p className={classes.text}>
          {successMessage} <span className={classes.bold}>{routeCode}</span>
        </p>
        <p className={classes.text}>{SCHEDULE_WARNING_MESSAGE}</p>
        <p className={classes.text}>{SAVE_WARNING_MESSAGE}</p>
      </Box>
    </SliderCard>
  );
};

export default memo(SummaryCard);
